import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import {
  DateTimeField,
  NumberField,
  RelationshipField,
  StringField,
} from "../plugins/Cruxtify/field-types";

import {
  DateTimeProperty,
  NumberProperty,
  RelationshipProperty,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import { ErCrudModel } from "./ErCrudModel";

export class Notification extends ErCrudModel {
  public static icon = "mdi-message-badge-outline";
  protected static _typeLabel = "Notification";
  protected static asProperty = "notification";
  public static api = {
    path: "notifications",
  };
  protected static routeBase = "notifications";
  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Read,
    },
    UserPermission.Hidden
  );

  protected userIdField = ["user"];

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Entry Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Entry Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "deleted_at",
        label: "Entry Deleted At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "message_id",
        label: "Mailgun ID",
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "status",
        label: "Delivery Status",
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "token",
        label: "Notification Token",
      },
    },

    {
      type: RelationshipProperty,
      opts: {
        name: "user",
        label: "User",
        relatedModel: "User",
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "mailer_template",
        label: "Mailer Template",
        relatedModel: "MailerTemplate",
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "submission",
        label: "Case Submission",
        relatedModel: "Submission",
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "expert",
        label: "Expert",
        relatedModel: "Expert",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    {
      type: DateTimeField,
      opts: { property: "created_at" },
    },
    { type: DateTimeField, opts: { property: "updated_at" } },
    { type: DateTimeField, opts: { property: "deleted_at" } },
    {
      type: StringField,
      opts: { property: "message_id" },
    },
    {
      type: StringField,
      opts: { property: "token" },
    },
    {
      type: StringField,
      opts: { property: "status" },
    },
    {
      type: RelationshipField,
      opts: {
        property: "user",
      },
    },
    {
      type: RelationshipField,
      opts: {
        property: "mailer_template",
      },
    },
    {
      type: RelationshipField,
      opts: {
        property: "submission",
      },
    },
    {
      type: RelationshipField,
      opts: {
        property: "expert",
      },
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      id: "Crudform",
      fieldSets: [
        {
          id: "0",
          fields: ["user", "status", "mailer_template", "submission", "expert"],
        },
        {
          id: "meta",
          fields: ["message_id", "token", "created_at", "id"],
        },
      ],
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      useModal: true,
      columnFields: [
        "created_at",
        "user",
        "status",
        "mailer_template",
        "submission",
        "expert",
      ],
      enableSearch: true,
      enableDynamicFilters: true,
      dynamicFilterOptions: {
        filterFields: [
          "created_at",
          "user",
          "mailer_template",
          "submission",
          "status",
          "updated_at",
          "expert",
          "message_id",
          "token",
        ],
      },
      defaultSort: [
        {
          field: "created_at",
          order: "desc",
        },
      ],
    },
  ];

  public static async validateToken(token: string) {
    return this.$nuxt.$api.POST("validate-token", { token });
  }
}
